import script from "./ZakatOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./ZakatOptions.vue?vue&type=script&setup=true&lang=js"

import "./ZakatOptions.vue?vue&type=style&index=0&id=5cc38d04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc38d04"]])

export default __exports__